/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {isLogin} from '../../utils';
import {
    Redirect,
} from "react-router-dom";

class CheckIsLogin extends Component {

    render() {
        if (isLogin() || window.location.href.indexOf('auth/google') > -1 ) {
            return null;
        }

        return (<Redirect to='/login'/>);
    }
}

export {CheckIsLogin};
